<template>
<div :class="$style['err-doctor-dialog']">
    <el-dialog :visible="dialogVisible" :title="dialogTitle" @close="cancel">
            <div>
              <p>本次共导入{{errDoctorList.total}}条数据，导入成功{{errDoctorList.successNumber}}条，失败{{errDoctorList.failNumber}}条。</p>
              <p v-if="errDoctorList.failNumber !== 0">请点击下载查看具体导入失败数据。</p>
            </div>
        <div :class="$style['button-div']">
          <el-button type="primary" @click="downLoad(errDoctorList.errorViewUrl)" v-if="errDoctorList.failNumber !== 0">下载</el-button>
          <el-button type="primary" @click="cancel" v-else>确定</el-button>
      </div>
    </el-dialog>
</div>
</template>
<script>
import { errDoctorLabels } from '../hospital-and-doctor-manage'
export default {
  name: 'err-doctor-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 8
    },
    errDoctorList: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      tableLabels: errDoctorLabels,
      selectIndex: '',
      page: 0
    }
  },
  watch: {
    page (val) {
      this.selectIndex = ''
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    downLoad (url) {
      location.href = url
    }
  }
}
</script>
<style module lang="less">
@import "~less/var";
.err-doctor-dialog{
    :global{
      .el-dialog__body{
        padding: 0 .2rem;
      }
    }
    .button-div{
      margin: .3rem 0;
    }
}
</style>
